// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { TenantPresentationConfiguration_HouseholdFragment, TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment } from '../../../../presentation/graphql/TenantPresentationConfiguration.generated';
import { EntityDiagramAndNotesSlide_EntityFragment } from '../../../../presentation/slides/EntityDiagramAndNotesSlide/graphql/EntityDiagramAndNotesSlide.generated';
import { ClientPresentationDesignerV2_EntityFragment } from '../../../../presentation/clientPresentation/graphql/ClientPresentationDesignerV2.generated';
import { gql } from '@apollo/client';
import { TenantPresentationConfiguration_HouseholdFragmentDoc, TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc } from '../../../../presentation/graphql/TenantPresentationConfiguration.generated';
import { EntityDiagramAndNotesSlide_EntityFragmentDoc } from '../../../../presentation/slides/EntityDiagramAndNotesSlide/graphql/EntityDiagramAndNotesSlide.generated';
import { ClientPresentationDesignerV2_EntityFragmentDoc } from '../../../../presentation/clientPresentation/graphql/ClientPresentationDesignerV2.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPreviewModalQueryVariables = Types.Exact<{
  entityWhere: Types.EntityWhereInput;
}>;


export type EntityPreviewModalQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity', household: (
          { __typename?: 'Household' }
          & TenantPresentationConfiguration_HouseholdFragment
        ) }
        & EntityPreviewModal_EntityFragment
      ) | null } | null> | null }, tenantInformation: { __typename?: 'TenantInformation', id: string, disclosuresConfiguration?: (
      { __typename?: 'TenantDisclaimerConfiguration' }
      & TenantPresentationConfiguration_TenantDisclaimerConfigurationFragment
    ) | null } };

export type EntityPreviewModal_EntityFragment = (
  { __typename?: 'Entity', id: string }
  & EntityDiagramAndNotesSlide_EntityFragment
  & ClientPresentationDesignerV2_EntityFragment
);

export const Operations = {
  Query: {
    EntityPreviewModal: 'EntityPreviewModal' as const
  },
  Fragment: {
    EntityPreviewModal_Entity: 'EntityPreviewModal_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityPreviewModal_EntityFragmentDoc = gql`
    fragment EntityPreviewModal_Entity on Entity {
  id
  ...EntityDiagramAndNotesSlide_Entity
  ...ClientPresentationDesignerV2_Entity
}
    ${EntityDiagramAndNotesSlide_EntityFragmentDoc}
${ClientPresentationDesignerV2_EntityFragmentDoc}`;
export const EntityPreviewModalDocument = gql`
    query EntityPreviewModal($entityWhere: EntityWhereInput!) {
  entities(where: $entityWhere) {
    edges {
      node {
        ...EntityPreviewModal_Entity
        household {
          ...TenantPresentationConfiguration_Household
        }
      }
    }
  }
  tenantInformation {
    id
    disclosuresConfiguration {
      ...TenantPresentationConfiguration_TenantDisclaimerConfiguration
    }
  }
}
    ${EntityPreviewModal_EntityFragmentDoc}
${TenantPresentationConfiguration_HouseholdFragmentDoc}
${TenantPresentationConfiguration_TenantDisclaimerConfigurationFragmentDoc}`;

/**
 * __useEntityPreviewModalQuery__
 *
 * To run a query within a React component, call `useEntityPreviewModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPreviewModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPreviewModalQuery({
 *   variables: {
 *      entityWhere: // value for 'entityWhere'
 *   },
 * });
 */
export function useEntityPreviewModalQuery(baseOptions: Apollo.QueryHookOptions<EntityPreviewModalQuery, EntityPreviewModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPreviewModalQuery, EntityPreviewModalQueryVariables>(EntityPreviewModalDocument, withFetchPolicyContext(options));
      }
export function useEntityPreviewModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPreviewModalQuery, EntityPreviewModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPreviewModalQuery, EntityPreviewModalQueryVariables>(EntityPreviewModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEntityPreviewModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityPreviewModalQuery, EntityPreviewModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityPreviewModalQuery, EntityPreviewModalQueryVariables>(EntityPreviewModalDocument, withFetchPolicyContext(options));
        }
export type EntityPreviewModalQueryHookResult = ReturnType<typeof useEntityPreviewModalQuery>;
export type EntityPreviewModalLazyQueryHookResult = ReturnType<typeof useEntityPreviewModalLazyQuery>;
export type EntityPreviewModalSuspenseQueryHookResult = ReturnType<typeof useEntityPreviewModalSuspenseQuery>;
export type EntityPreviewModalQueryResult = Apollo.QueryResult<EntityPreviewModalQuery, EntityPreviewModalQueryVariables>;